/* BSFA global enhancements
   Sostituisce la sezione "Why Bulkshopforall?" (immagini con testo inglese)
   con 3 box testuali in tedesco, pertinenti alle licenze digitali. */
/* Helper i18n locale a questo file: legge da window.BSFA_I18N.testimonials
   (iniettato da snippets/custom-code-head.liquid tramite le chiavi | t di
   locales/*.json, namespace snippets.bsfa_testimonials_autoplay) con fallback
   al tedesco originale, cosi' il testo segue la lingua del negozio. */
function BSFA_TT(key, fallback) {
  try {
    var v = window.BSFA_I18N && window.BSFA_I18N.testimonials && window.BSFA_I18N.testimonials[key];
    return (v !== undefined && v !== null && v !== '') ? v : fallback;
  } catch (e) { return fallback; }
}
function BSFA_TTK(key, fallback) {
  try {
    if (window.BSFA_IS_KONTO && window.BSFA_I18N && window.BSFA_I18N.testimonials_konto && window.BSFA_I18N.testimonials_konto[key]) {
      return window.BSFA_I18N.testimonials_konto[key];
    }
  } catch (e) {}
  return BSFA_TT(key, fallback);
}
(function () {
  var SVG_MAIL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>';
  var SVG_SHIELD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 5 6v5c0 4.5 3 7.6 7 9 4-1.4 7-4.5 7-9V6l-7-3Z"/><path d="m9 12 2 2 4-4"/></svg>';
  var SVG_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></svg>';
  var SVG_SUPPORT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 13a8 8 0 0 1 16 0"/><rect x="2" y="13" width="4" height="7" rx="1.5"/><rect x="18" y="13" width="4" height="7" rx="1.5"/><path d="M20 20a3 3 0 0 1-3 2h-3"/></svg>';

  /* BSFA: costruito in modo lazy (non a module scope) perche' deve leggere
     window.BSFA_IS_KONTO e usare i testi Konto-specifici sui prodotti
     "Kontozugang" (nessun product key, durata 12 mesi). */
  function buildWHY() {
  var isK = !!window.BSFA_IS_KONTO;
  return '' +
    '<div class="bsfa-why">' +
      '<h2 class="bsfa-why__title">' + BSFA_TT('why_title', 'Warum BulkShopForAll?') + '</h2>' +
      '<div class="bsfa-why__grid">' +
        '<div class="bsfa-why__box">' +
          '<div class="bsfa-why__ic">' + SVG_MAIL + '</div>' +
          '<h3>' + BSFA_TTK('why_box1_title', 'Sofort per E-Mail') + '</h3>' +
          '<p>' + BSFA_TTK('why_box1_text', 'Lizenzschlüssel und Download-Link kommen direkt nach dem Kauf in Ihr Postfach – ganz ohne Wartezeit.') + '</p>' +
        '</div>' +
        '<div class="bsfa-why__box">' +
          '<div class="bsfa-why__ic">' + (isK ? SVG_CLOCK : SVG_SHIELD) + '</div>' +
          '<h3>' + BSFA_TTK('why_box2_title', 'Klar beschriebene Produkte') + '</h3>' +
          '<p>' + BSFA_TTK('why_box2_text', 'Digitale Produkte mit klar beschriebenem Lieferumfang und Rechnung.') + '</p>' +
        '</div>' +
        '<div class="bsfa-why__box">' +
          '<div class="bsfa-why__ic">' + SVG_SUPPORT + '</div>' +
          '<h3>' + BSFA_TTK('why_box3_title', 'Support an 7 Tagen') + '</h3>' +
          '<p>' + BSFA_TTK('why_box3_text', 'Unser Team unterstützt Sie bei Installation und Aktivierung – freundlich und schnell.') + '</p>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function inject() {
    var secs = document.querySelectorAll('[data-section-type="icon-box"]');
    secs.forEach(function (sec) {
      if (sec.dataset.bsfaWhy) return;
      var h = sec.querySelector('h1,h2,h3,h4');
      if (h && /bulkshopforall/i.test(h.textContent)) {
        sec.dataset.bsfaWhy = '1';
        sec.innerHTML = buildWHY();
      }
    });
  }
  var tries = 0;
  var iv = setInterval(function () { tries++; inject(); if (tries > 12) clearInterval(iv); }, 500);
  if (document.readyState !== 'loading') inject();
  else document.addEventListener('DOMContentLoaded', inject);
  window.addEventListener('load', inject);
})();

/* BSFA: bandiere lingua nel selettore + rilevamento automatico della lingua.
   Funziona da subito per la bandiera della lingua attiva; le altre lingue e
   l'auto-rilevamento si attivano AUTOMATICAMENTE quando vengono pubblicate
   altre lingue in Shopify Admin (Impostazioni > Lingue). */
(function () {
  var FLAGS = {
    de: '<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" y="0" fill="#000000"/><rect width="5" height="1" y="1" fill="#DD0000"/><rect width="5" height="1" y="2" fill="#FFCE00"/></svg>',
    en: '<svg viewBox="0 0 60 30" preserveAspectRatio="none"><rect width="60" height="30" fill="#012169"/><path d="M0,0 60,30 M60,0 0,30" stroke="#ffffff" stroke-width="6"/><path d="M0,0 60,30 M60,0 0,30" stroke="#C8102E" stroke-width="4"/><path d="M30,0 V30 M0,15 H60" stroke="#ffffff" stroke-width="10"/><path d="M30,0 V30 M0,15 H60" stroke="#C8102E" stroke-width="6"/></svg>',
    it: '<svg viewBox="0 0 3 2" preserveAspectRatio="none"><rect width="1" height="2" x="0" fill="#009246"/><rect width="1" height="2" x="1" fill="#ffffff"/><rect width="1" height="2" x="2" fill="#CE2B37"/></svg>',
    es: '<svg viewBox="0 0 3 2" preserveAspectRatio="none"><rect width="3" height="2" fill="#AA151B"/><rect width="3" height="1" y="0.5" fill="#F1BF00"/></svg>',
    fr: '<svg viewBox="0 0 3 2" preserveAspectRatio="none"><rect width="1" height="2" x="0" fill="#0055A4"/><rect width="1" height="2" x="1" fill="#ffffff"/><rect width="1" height="2" x="2" fill="#EF4135"/></svg>'
  };
  var NAME2CODE = { 'deutsch': 'de', 'german': 'de', 'english': 'en', 'englisch': 'en', 'italiano': 'it', 'italian': 'it', 'italienisch': 'it', 'español': 'es', 'espanol': 'es', 'spanish': 'es', 'spanisch': 'es', 'français': 'fr', 'francais': 'fr', 'french': 'fr', 'französisch': 'fr' };

  function flag(code) { code = (code || '').slice(0, 2).toLowerCase(); return FLAGS[code] || ''; }
  function mkFlag(code) { var s = document.createElement('span'); s.className = 'bsfa-flag'; s.innerHTML = flag(code); return s; }
  function codeFromText(t) { return NAME2CODE[(t || '').trim().toLowerCase()] || ''; }

  function decorate() {
    document.querySelectorAll('.shopify-localization-form').forEach(function (form) {
      var sel = form.querySelector('select[data-localization-select], .js-selectNative');
      var current = '';
      if (sel) { current = sel.value || ((sel.querySelector('option[selected]') || {}).value || ''); }
      if (!current) { var hid = form.querySelector('input[name="locale_code"]'); if (hid) current = hid.value; }

      var trigText = form.querySelector('.m-select-custom--trigger-text, .m-select-custom--trigger');
      if (trigText && !trigText.querySelector('.bsfa-flag')) {
        var c = current || codeFromText(trigText.textContent);
        if (flag(c)) trigText.insertBefore(mkFlag(c), trigText.firstChild);
      }

      var opts = form.querySelectorAll('.m-select-custom--options [data-value], .m-select-custom--options li, .m-select-custom--options a, .m-select-custom--option, [data-localization-option]');
      opts.forEach(function (opt) {
        if (opt.querySelector('.bsfa-flag')) return;
        var code = opt.getAttribute('data-value') || opt.getAttribute('data-localization-option') || codeFromText(opt.textContent);
        if (flag(code)) { opt.classList.add('bsfa-lang-opt'); opt.insertBefore(mkFlag(code), opt.firstChild); }
      });
    });
  }

  function autoLang() {
    try {
      if (localStorage.getItem('bsfa_lang_set')) return;
      var form = document.querySelector('.shopify-localization-form');
      if (!form) return;
      var sel = form.querySelector('select[data-localization-select], .js-selectNative');
      if (!sel || !sel.options) return;
      var codes = Array.prototype.map.call(sel.options, function (o) { return (o.value || '').slice(0, 2).toLowerCase(); });
      if (codes.length < 2) return; /* una sola lingua: niente da fare */
      var current = (sel.value || '').slice(0, 2).toLowerCase();
      var prefs = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || ''];
      var best = null;
      for (var i = 0; i < prefs.length; i++) { var c = (prefs[i] || '').slice(0, 2).toLowerCase(); if (codes.indexOf(c) >= 0) { best = c; break; } }
      localStorage.setItem('bsfa_lang_set', '1');
      if (!best || best === current) return;
      var hidden = form.querySelector('input[name="locale_code"]'); if (hidden) hidden.value = best;
      sel.value = best;
      var rt = form.querySelector('input[name="return_to"]'); if (rt) rt.value = location.pathname + location.search;
      form.submit();
    } catch (e) {}
  }

  /* se l'utente cambia lingua a mano, non sovrascrivere più automaticamente */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('select[data-localization-select], .js-selectNative')) {
      try { localStorage.setItem('bsfa_lang_set', '1'); } catch (_) {}
    }
  }, true);

  function run() { decorate(); autoLang(); }
  var n = 0;
  var iv = setInterval(function () { n++; decorate(); if (n > 10) clearInterval(iv); }, 600);
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();

/* BSFA: blocco "garanzie" nella pagina prodotto (sotto i bottoni d'acquisto). */
(function () {
  var HTML = '' +
    '<div class="bsfa-guarantee">' +
      '<div class="bsfa-guarantee__item"><span class="bsfa-guarantee__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z"/></svg></span><span class="bsfa-guarantee__tx"><strong>' + BSFA_TT('guarantee_delivery_title', 'Sofortige Lieferung') + '</strong><span>' + BSFA_TTK('guarantee_delivery_text', 'Schlüssel & Download per E-Mail') + '</span></span></div>' +
      '<div class="bsfa-guarantee__item"><span class="bsfa-guarantee__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg></span><span class="bsfa-guarantee__tx"><strong>' + BSFA_TTK('guarantee_original_title', 'Klar beschriebene Produkte') + '</strong><span>' + BSFA_TTK('guarantee_original_text', 'Lieferumfang und Laufzeit klar angegeben') + '</span></span></div>' +
      '<div class="bsfa-guarantee__item"><span class="bsfa-guarantee__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span><span class="bsfa-guarantee__tx"><strong>' + BSFA_TT('guarantee_buyer_title', 'Käuferschutz') + '</strong><span>' + BSFA_TT('guarantee_buyer_text', 'Sichere & verschlüsselte Zahlung') + '</span></span></div>' +
    '</div>';

  function inject() {
    if (document.querySelector('.bsfa-guarantee')) return true;
    var wrap = document.querySelector('.m-product-info--wrapper');
    if (!wrap) return false;
    var anchor = wrap.querySelector('.bsfa-bb') || wrap.querySelector('.payment-icons');
    var div = document.createElement('div');
    div.innerHTML = HTML;
    var node = div.firstChild;
    if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(node, anchor); return true; }
    wrap.appendChild(node);
    return true;
  }
  var t = 0;
  var iv2 = setInterval(function () { t++; if (inject() || t > 14) clearInterval(iv2); }, 500);
  if (document.readyState !== 'loading') inject();
  else document.addEventListener('DOMContentLoaded', inject);
  window.addEventListener('load', inject);
})();
